import { AlertType } from "@tandemdiabetes/sugarmate-api-react-client"

import { Contacts } from "../Contacts"
import styles from "./SMSAlerts.module.scss"
import { UrgentLowThreshold } from "./UrgentLowThreshold"
import { UrgentLowToggle } from "./UrgentLowToggle"
import { useTestSMSAlertFunctionality } from "./useTestSMSAlertFunctionality"

import { PageTemplate } from "src/components"
import {
  useFollowedUsers,
  usePolyglot,
} from "src/contexts"
import {
  useAlert,
  useDebouncedUpdateAlert,
} from "src/hooks"

export function SMSAlerts() {
  const polyglot = usePolyglot()
  const urgentLowSMS = useAlert(AlertType.UrgentLowSMS)

  const {
    currentUserId,
    currentFollow,
  } = useFollowedUsers()

  const debouncedUpdatePartialAlert = useDebouncedUpdateAlert(
    urgentLowSMS,
    "sms-alerts-update-error-toast",
  )

  const testFunctionality = useTestSMSAlertFunctionality(urgentLowSMS)

  return (
    <PageTemplate
      user="follow"
      title={polyglot.t("components.page_header.pages.sms")}
      backRoutePath={currentFollow.is_self ? "/settings/alerts" : "/settings/alerts/$accountId"}
      backRouteParams={currentFollow.is_self ? {} : { accountId: currentUserId }}
    >
      <div className={styles.container}>
        {urgentLowSMS && (
          <UrgentLowToggle
            urgentLowSMS={urgentLowSMS}
            updateAlert={debouncedUpdatePartialAlert}
          />
        )}
        {urgentLowSMS?.is_active && (
          <>
            <UrgentLowThreshold
              urgentLowSMS={urgentLowSMS}
              updateAlert={debouncedUpdatePartialAlert}
            />
            <Contacts
              maxNumberOfContacts={5}
              sugarmateAlert={urgentLowSMS}
              testFunctionality={testFunctionality}
            />
          </>
        )}
      </div>
    </PageTemplate>
  )
}
